<template>
  <div class="global-notice" v-if="false">
    <el-icon icon="warning"></el-icon>
    我是一段提示信息
  </div>
</template>

<script>
  import business from './index';

  export default {
    name: 'global-notice',

    created () {
      business.init();
    },
  };
</script>

<style lang="less" src="./index.less"></style>
